﻿import { ensureLazySizes } from "@js/core/loaders/vendors";

export async function initLazySizes() {
    const lazyItems = document.querySelectorAll(".lazyload, img[data-src], source[data-srcset]");
    if (!lazyItems.length) return;

    await ensureLazySizes();
}